import { render, staticRenderFns } from "./Requestdel.vue?vue&type=template&id=d1feb41e&scoped=true"
import script from "./Requestdel.vue?vue&type=script&lang=js"
export * from "./Requestdel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1feb41e",
  null
  
)

export default component.exports